import { sendProductReviewsEvent } from 'src/tracking/sendProductReviewsEvent';

/** Once per settled movement, with the direction as the label, like the other PDP carousels. */
export const trackPreviewScroll = (direction: 'next' | 'previous') =>
  sendProductReviewsEvent('Reviews preview scroll', direction);

export const trackPreviewImpression = () =>
  sendProductReviewsEvent('Reviews preview impression', 'not set');

/** All four card controls open the same review, so the control is the label rather than four events. */
export const trackReviewCardControlClick = (control: string) =>
  sendProductReviewsEvent('Review card control click', control);
